<template>
  <div class="p-fluid grid formgrid">
    <div class="field col-12">
      <label>FQDN</label>
      <InputText type="text" v-model="fqdn" class="flex-grow-1" placeholder="meine.subdomain.net" autofocus/>
      <label class="mt-3">Typ</label>
      <Dropdown v-model="type" :options="mapEnum['type']" optionLabel="name" optionValue="id" placeholder="Wählen" />
    </div>
  </div>
  <div class="flex flex-row mt-4 justify-content-end w-full">
    <Button label="Abbrechen" icon="pi pi-times" @click="closeDialog(false)" class="p-button-text mr-2"/>
    <Button :disabled="!fqdn.length || !type" label="Ok" icon="pi pi-check" @click="requestCloseDialog" autofocus />
  </div>
</template>

<script>

export default {
  inject: ['dialogRef'],
  name: "NewDomainDialog",
  data() {
    return {
      fqdn:"",
      type:"",
      mapEnum: {
        type:[{id:1,name:"A"},{id:2,name:"CNAME"}],
      },
    }
  },
  async created() {
    let params = this.dialogRef.data;
    if (params) {
      this.val = params.val;
    }
  },
  methods: {
    closeDialog(ok=true) {
      this.dialogRef.close(ok ? {
        fqdn:this.fqdn,
        type:this.type
      } : null);
    },
    isValid() {
      return this.fqdn.match(/^([a-zA-Z0-9]+(-[a-zA-Z0-9]+)*\.)+[a-zA-Z]{2,}$/) && this.type>0;
    },
    requestCloseDialog() {
      if (this.isValid())
        this.closeDialog();
      else {
        this.$toast.add({severity:'error', summary: 'Fehler', detail:"Ihre Eingaben sind nicht korrekt", life: 3000})
      }
    }
  }
}
</script>

<style scoped>

</style>